module.exports = "/images/HongKong.png?b1f553ebe94022000e36fcdd116d02f9";